import {
  Typography,
  Button,
  Box,
  Slider,
  CircularProgress,
  styled,
  List,
  ListItem,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useEffect, useState } from "react";

function LandingComp(props) {
  const [start, setStarted] = useState(false);
  useEffect(() => {
    window.addEventListener("transitionend", (e) => {
      if (e.target.id === "webxr-landing-page") {
        props.setArStarted(true);
      }
    });
  });
  return (
    <Box
      id='webxr-landing-page'
      sx={{
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "4000",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        gap: "20px",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundColor: "#0E1116",
        transition: "opacity 0.5s",
      }}
    >
      <Box
        component='img'
        src='.\assets\images\cropped-veer-goggles-logo-rect.png'
        sx={{
          width: "80%",
          maxWidth: "300px",
          margin: "40px 0 10px 0",
          zIndex: "-10",
        }}
      ></Box>
      <List
        sx={{
          maxWidth: "70vw",
          fontSize: "0.9em",
          fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
          color: "rgba(236, 231, 221, 0.75)",
        }}
      >
        <ListItem sx={{ color: "inherit" }}>
          By allowing Camera Access, you will enable a custom parallax engine
          for Three.js that uses Augmented Reality face-tracking to enable
          passive background animation.
        </ListItem>
        <ListItem sx={{ color: "inherit" }}>
          The experience brings my father's childhood to life by combining
          black-and-white photos with AI color- and depth-estimation. Newly
          scanned objects and environments can take advantage of Gaussian
          Splatmaps and even generative AI rendering to take this capture
          fidelity to the next level.
        </ListItem>
        <ListItem sx={{ color: "inherit" }}>
          The future's interaction models are being pioneered now. Let's build
          them together.
        </ListItem>
      </List>

      {start ? (
        <CircularProgress
          sx={{
            color: "#D69B52",
          }}
        />
      ) : (
        <Button
          onClick={() => {
            props.startAR();
            setStarted(true);
          }}
          sx={{
            border: "1px solid rgba(236, 231, 221, 0.28)",
            color: "#ECE7DD",
            marginTop: "-25px",
            fontFamily: '"Space Mono", ui-monospace, monospace',
            letterSpacing: "0.08em",
            borderRadius: "999px",
            "&:hover": {
              borderColor: "#D69B52",
              color: "#D69B52",
              backgroundColor: "transparent",
            },
          }}
          variant='outlined'
          endIcon={<ArrowRightIcon />}
        >
          Launch Portfolio
        </Button>
      )}
    </Box>
  );
}

export default LandingComp;
